import React from "react";
import PropTypes from "prop-types";

export default class ItemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreButton: props.showMoreButton || false
    }

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    this.setState({showMoreButton: false});
  }

  render() {
    const { items, options, label } = this.props;
    const { showMoreButton } = this.state;

    const expandClass = showMoreButton ? "digest-card__items--hidden-list" : "";

    return (
      <div className={`digest-card__items ${expandClass}`}>
        <span className="digest-card__label">{ label + " - " }</span>
        { items.map((item, i) => {
          let spacer = i < items.length - 2
            ? options.item_concatenator + " "
            : i === items.length - 2
              ? " " + options.last_item_symbol + " "
              : "";
          return <span key={i} dangerouslySetInnerHTML={{ __html: item + spacer }}></span>;
        }) }
        {showMoreButton && (
          <button type="button" className="digest-card__view-more-button" aria-label="show more authors" aria-expanded="false" onClick={this.handleClick}>et al. (View all)</button>
        )}
      </div>
    );
  }
}

const { array, object, string } = PropTypes;

ItemList.propTypes = {
  items: array,
  options: object,
  label: string
};

ItemList.defaultProps = {
  options: {
    "last_item_symbol": "&",
    "item_concatenator": ","
  }
};